
import MAHistoryPanel from "@/components/analyze/MAHistoryPanel.vue";
import MLearningSummaryCard from "@/components/MLearningSummaryCard.vue";
import { LearningSummaryData } from "@/components/MLearningSummaryCard.vue";
import store from "@/store";
import { Options, Vue } from "vue-class-component";
import { Student } from "@/entities/student";
import dayjs from "dayjs";

@Options({
  components: {
    MAHistoryPanel,
    MLearningSummaryCard
  },
  props: {
    student: Object
  }
})
export default class Home extends Vue {
  student!: Student;

  get point(): LearningSummaryData[] {
    return [
      {
        num: store.getters.totalLearningDayCount,
        label: "日"
      }
    ];
  }

  get currentRunningDayCount(): LearningSummaryData[] {
    return [
      {
        num: store.getters.consecutiveLearningDayCount,
        label: "日"
      }
    ];
  }

  get maxRunningDayCount(): LearningSummaryData[] {
    return [
      {
        num: store.getters.maxConsecutiveLearningDayCount,
        label: "日"
      }
    ];
  }

  get lastWeekStartTime() {
    const start = dayjs()
      .locale("ja")
      .add(-6, "day")
      .startOf("day");
    return start.unix();
  }
  get lastWeekEndTime() {
    const end = dayjs()
      .locale("ja")
      .endOf("day");
    return end.unix();
  }
}
